import React from "react";
import { useNavigate } from "react-router-dom";
import {
	Box,
	Paper,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	Typography,
	Chip,
	IconButton,
	Stack,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

type Product = {
	id: string;
	name: string;
	brand?: string;
};

const mockProducts: Product[] = [
	{ id: "p1", name: "Producto A", brand: "Marca Alpha" },
	{ id: "p2", name: "Producto B", brand: "Marca Beta" },
	{ id: "p3", name: "Producto C", brand: "Marca Gamma" },
];

type Props = {
	products?: Product[];
	reviewsCount?: Record<string, number>;
};

const BrandReports: React.FC<Props> = ({ products = mockProducts, reviewsCount }) => {
	const navigate = useNavigate();

	// valores por defecto si no vienen desde props
	const defaultCounts: Record<string, number> = {
		p1: 3,
		p2: 1,
		p3: 5,
	};

	const countsMap = reviewsCount && Object.keys(reviewsCount).length > 0 ? reviewsCount : defaultCounts;

	return (
		<Box sx={{ width: "100%", mx: "auto", p: 2 }}>
			<Paper elevation={3} sx={{ p: 3 }}>
				<Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
					<Typography variant="h6">Marcas — Resultados</Typography>
					<Typography variant="body2" color="text.secondary">
						{products.length} productos
					</Typography>
				</Stack>

				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell sx={{ fontWeight: 600 }}>Código</TableCell>
								<TableCell sx={{ fontWeight: 600 }}>Nombre</TableCell>
								<TableCell sx={{ fontWeight: 600 }}>Marca</TableCell>
								<TableCell sx={{ fontWeight: 600, width: 120 }}>Reseñas</TableCell>
								<TableCell sx={{ fontWeight: 600, width: 220, textAlign: "right" }}>Acciones</TableCell>
							</TableRow>
						</TableHead>

						<TableBody>
							{products.map((p) => (
								<TableRow key={p.id} hover>
									<TableCell>
										<Stack direction="row" alignItems="center" spacing={2}>
											<Typography variant="body2" sx={{ fontWeight: 600 }}>
												{p.id}
											</Typography>
										</Stack>
									</TableCell>

									<TableCell>
										<Typography variant="body2">{p.name}</Typography>
									</TableCell>

									<TableCell>
										<Typography variant="body2" color="text.secondary">
											{p.brand ?? "—"}
										</Typography>
									</TableCell>

									<TableCell>
										<Chip label={countsMap[p.id] ?? 0} color="info" size="small" />
									</TableCell>

									<TableCell align="right">
										<Stack direction="row" spacing={1} justifyContent="flex-end">
											<IconButton
												color="primary"
												aria-label="ver detalles icono"
												onClick={() => navigate(`/on-six/brands/${encodeURIComponent(p.id)}`)}
												size="large"
											>
												<VisibilityIcon />
											</IconButton>
										</Stack>
									</TableCell>
								</TableRow>
							))}

							{products.length === 0 && (
								<TableRow>
									<TableCell colSpan={5}>
										<Typography variant="body2" align="center" color="text.secondary" sx={{ py: 2 }}>
											No hay productos para mostrar.
										</Typography>
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			</Paper>
		</Box>
	);
};

export default BrandReports;